import React, { Component, Fragment } from "react";
import "./Site.css";
import {
  Row,
  Col,
  Button,
  ListGroup,
  ListGroupItem,
  ButtonGroup,
  Badge
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Pager, SearchRecord  } from "../components";
import { api, filterHelper,  uiHelper, constant } from "../helpers";
import Alert from "react-s-alert";
import { Link } from "react-router-dom";
import moment from "moment";
import _ from "lodash";

export default class EquipmentMaintenanceRecord extends Component {
  static displayName = EquipmentMaintenanceRecord.name;
  constructor(props) {
    super(props);
    this.state = {
      message: null,
      messageColor: null,
      isMessageVisible: false,
      filters: [],
      pagedList: null,
      sortColumn: "MaintenanceDate",
      sortAscending: false,
      searchValue: '',
      hasDateFilter: false
    };
    this.refreshList = this.refreshList.bind(this);
    this.clearFilters = this.clearFilters.bind(this);
    this.onChangeFilter = this.onChangeFilter.bind(this);
    this.setPage = this.setPage.bind(this);
    this.onDismiss = this.onDismiss.bind(this);
    this.downloadReport = this.downloadReport.bind(this);
  }

  componentDidMount() {
    this.refreshList();
  }

  onDismiss() {
    this.setState({
      isMessageVisible: !this.state.isMessageVisible,
      message: null,
      messageColor: null,
    });
  }

  refreshList(sortColumn, sortAscending, filters, pageNumber) {
    const resolvedFilters = filters || this.state.filters;
    const resolvedSort = {
      sortColumn: sortColumn || this.state.sortColumn,
      sortAscending: sortAscending || this.state.sortAscending
    };
    const payload = {
      activeOnly: null,
      name: null,
      ...resolvedSort,
      ...filterHelper.filtersToObject(resolvedFilters),
      pageSize: 50,
      page: pageNumber || (this.state.pagedList ? this.state.pagedList.pageNumber : 1)
    };
    api.post("Equipment/MaintenanceRecords", payload)
      .then(response => {
        if (response.data) {
          let plist = _.map(response.data.dataSource, x => {
            x.collapse = false;
            return x;
          });
          this.setState({
            ...resolvedSort,
            pagedList: {
              list: plist,
              pageNumber: response.data.page,
              pageSize: response.data.pageSize,
              totalItems: response.data.totalItems,
              totalPages: response.data.totalPages
            },
            filters: resolvedFilters,
          });
        }
      })
  }

  setPage(page) {
    this.refreshList(null, null, null, page);
  }

  clearFilters() {
    const filters = [];
    this.setState({ filters: filters });
    this.refreshList(null, null, filters);
  }

  onChangeFilter(changedFilter) {
    const filters = filterHelper.getFilters(
      this.state.filters,
      changedFilter
    );
    let hasDateFilter = _.find(filters, f => {
      return f.filterName === 'fromDate' || f.filterName === 'toDate';
    })
    this.setState({
      filters: filters,
      hasDateFilter: hasDateFilter !== undefined 
        ? true
        : false
    },
      () => { this.refreshList(null, null, filters, 1) }
    );
  }

  onView(maintenanceRecordId, index) {
    var list = this.state.pagedList.list.slice();
    list[index].collapse = !list[index].collapse
    this.setState({
      pagedList: { ...this.state.pagedList, list: list}
    })
  }

  downloadReport() {
    const resolvedFilters = this.state.filters;
    const resolvedSort = {
      sortColumn: this.state.sortColumn,
      sortAscending: this.state.sortAscending
    };
    const payload = {
      activeOnly: null,
      name: null,
      ...resolvedSort,
      ...filterHelper.filtersToObject(resolvedFilters),
    };
    api.postFormDataGetBlob("Equipment/ExportMaintenanceReport", payload)
      .then(response => {
        if (response.status === 200) {
          const XLSX_MIME = "application/vnd.openxmlformats-officedocument.spreadsheetml";
          const XLSX_FILENAME = `maintenance_report.xlsx`;
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(response.data, XLSX_FILENAME);
          }
          else {
            const file = new Blob([response.data], { type: XLSX_MIME });
            var anchor = window.document.createElement('a');
            anchor.download = XLSX_FILENAME;
            anchor.href = (window.webkitURL || window.URL).createObjectURL(file);
            anchor.dataset.downloadurl = [XLSX_MIME, anchor.download, anchor.href].join(':');
            anchor.click();
          }
        } else {
          throw new Error("Error downloading report");
        }
      }).catch(error => Alert.error(error));
  }

  render() {
    return (
      <div className="ml-4 mr-4">
        <Row className="pageTitle p-2">
          <Col>
            <h4>Equipment Maintenance Records</h4>
          </Col>
        </Row>

        <SearchRecord
          title={constant.maintenanceType.Calibration.name}
          url={"/maintenance_record/new"}
          filters={this.state.filters}
          onChangeFilter={this.onChangeFilter}
          hasDateFilter={this.state.hasDateFilter}
          downloadReport={this.downloadReport}
        />

        <Row className="p-2">
          <Col>
            <ListGroup>
              {this.state.pagedList && this.state.pagedList.list.length > 0 ? (
                this.state.pagedList.list.map((item, index) => (
                  <ListGroupItem key={`mainrec-${index}-${item.id}`} className="mb-2">
                    <Fragment>
                      <Row>
                        <Col xs="1">
                          <FontAwesomeIcon icon="tools" size="3x" />
                        </Col>
                        <Col>
                          <div><Badge color={uiHelper.resolveStatusColor(item.equipmentStatusName)}>{item.equipmentStatusName}</Badge></div>
                          <div className="boldText cbdmdBlueText">{item.equipmentName} - {item.referenceCode}</div>
                          <div>
                            <span className="boldText mr-2">Date Completed:</span>
                            <span>{moment(item.maintenanceDate).format("M/DD/YYYY")}</span>
                          </div>
                          {item.nextScheduledMaintenanceDate !== null &&
                            <div>
                              <span className="boldText mr-2">Next Scheduled Maintenance:</span>
                              <span>{moment(item.nextScheduledMaintenanceDate).format("M/DD/YYY")}</span>
                            </div>
                          }
                          {item.collapse && 
                            <div>
                              <span className="boldText mr-2">Completed By:</span>
                              <span>{item.vendorMechanicName}</span>
                            </div>

                          }
                        </Col>
                        <Col xs="1">
                          <ButtonGroup className="float-right">
                            <Button size="sm" className="cbdmdPrimary float-right buttonGroupSpacing" title={item.collapse ? "View less" : "View more"} onClick={() => this.onView(item.id, index)}>
                              <FontAwesomeIcon icon={item.collapse ? "eye-slash" : "eye"} />
                            </Button>
                            <Button size="sm" className="cbdmdPrimaryOutline float-right buttonGroupSpacing" title={"Edit"} tag={Link} to={`/maintenance_record/${item.id}`}>
                              <FontAwesomeIcon icon={"edit"} />
                            </Button>
                          </ButtonGroup>
                        </Col>
                      </Row>
                      {item.collapse && 
                        <Row>
                          <Col xs="1"></Col>
                          <Col>
                            <Row>
                              <Col xs="3" className="boldText">Summary Of Maintenance:</Col>
                              <Col>{item.summaryOfMaintenance}</Col>
                            </Row>
                            <Row>
                              <Col xs="3" className="boldText">Recommendations:</Col>
                              <Col>{item.recommendations}</Col>
                            </Row>
                          </Col>
                        </Row>
                      }
                    </Fragment>
                  </ListGroupItem>
                ))) : <div className="detailText">No Records Found</div>}
            </ListGroup>
            <Pager {...this.state.pagedList} callBack={this.setPage} />
          </Col>
        </Row>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/EquipmentMaintenanceRecord.js